import { get, post, remove, postfile } from "../common/http.services";

export function getInventory(searchData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/inventory?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getProductMargin(searchData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdmargin?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getInvAttribute(product: any, appContext: any, success: any, error: any) {
    return get(`/amazon/inventory/attribute?product=${product}`, appContext, success, error);
}

export function getTotalInventory(searchData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/inventory/total`, searchData, appContext, success, error);
}

export function getFeeData(searchData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/inventory/fee?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function exportFeeDataSku(appContext: any, success: any, error: any) {
    return get(`/amazon/inventory/fee/sku`, appContext, success, error);
}

export function exportInvData(appContext: any, success: any, error: any) {
    return get(`/amazon/inventory/export`, appContext, success, error);
}

export function exportSaleData(appContext: any, success: any, error: any) {
    return get(`/amazon/sale/export`, appContext, success, error);
}

export function exportTrnData(searchData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/export`, searchData, appContext, success, error);
}

export function getPerformance(data: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/performance?page=${pageNumber}&size=${pageSize}`, data, appContext, success, error);
}

export function getLog(pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/log?page=${pageNumber}&size=${pageSize}&sort=date,desc`, appContext, success, error);
}

export function deleteLog(rowId: any, appContext: any, success: any, error: any) {
    return remove(`/amazon/log?rowId=${rowId}`, appContext, success, error);
}

export function getPerfParam(dates: any, appContext: any, success: any, error: any) {
    return post(`/amazon/performance/param`, dates, appContext, success, error);
}

export function getTacosOverall(dates: any, appContext: any, success: any, error: any) {
    return post(`/amazon/adspend/tacos`, dates, appContext, success, error);
}

export function getPrdSaleOverall(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdsale/total`, data, appContext, success, error);
}

export function getPrdSalePieChart(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdsale/chart/pie`, data, appContext, success, error);
}

export function getPrdSaleBarChart(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdsale/chart/bar`, data, appContext, success, error);
}

export function getPrdRetTrendChart(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/return/trend`, data, appContext, success, error);
}

export function getPrdReturnReason(product: any, appContext: any, success: any, error: any) {
    return get(`/amazon/return/reason?product=${product}`, appContext, success, error);
}

export function getPrdReturnReasonComment(product: any, reason: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/return/reason/comment?product=${product}&reason=${reason}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getOrderTopSku(data: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/order/topsku?page=${pageNumber}&size=${pageSize}`, data, appContext, success, error);
}

export function getPrdSale(dates: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdsale/period?page=${pageNumber}&size=${pageSize}`, dates, appContext, success, error);
}

export function getSale(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/sale?page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getOrderCountTrend(date: any, appContext: any, success: any, error: any) {
    return get(`/amazon/order/count/trend?date=${date}`, appContext, success, error);
}

export function getOrderTrendSku(sku: any, appContext: any, success: any, error: any) {
    return get(`/amazon/order/trend?sku=${sku}`, appContext, success, error);
}

export function getOrderValueTrend(date: any, type: any, appContext: any, success: any, error: any) {
    return get(`/amazon/order/value/trend?date=${date}&type=${type}`, appContext, success, error);
}

export function getUnitTrend(date: any, type: any, appContext: any, success: any, error: any) {
    return get(`/amazon/unit/trend?date=${date}&type=${type}`, appContext, success, error);
}

export function saveRate(data: any,  appContext: any, success: any, error: any) {
    return post(`/amazon/rate`, data, appContext, success, error);
}

export function saveSale(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/sale`, data, appContext, success, error);
}

export function getPrdReturnOverall(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/return/total`, data, appContext, success, error);
}

export function exportComment(sDate: any, eDate: any, appContext: any, success: any, error: any) {
    return get(`/amazon/return/comment/export?sDate=${sDate}&eDate=${eDate}`, appContext, success, error);
}

export function getPrdReturn(data: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/return/period?page=${pageNumber}&size=${pageSize}`, data, appContext, success, error);
}

export function getProductSale(productData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/prdsale/product?page=${pageNumber}&size=${pageSize}`, productData, appContext, success, error);
}

export function getProductReturn(productData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/return/product?page=${pageNumber}&size=${pageSize}`, productData, appContext, success, error);
}

export function getOrder(searchData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/order?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getOrderCount(searchData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/order/count`, searchData, appContext, success, error);
}

export function getReturnComment(product: any, orderBy: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/return/comment?product=${product}&page=${pageNumber}&size=${pageSize}&sort=${orderBy}`, appContext, success, error);
}

export function getCosting(searchData: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/costing/search?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function getCostingHistory(sku: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/costing?sku=${sku}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function saveCosting(costingData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/costing`, costingData, appContext, success, error);
}

export function savePrice(priceData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/price`, priceData, appContext, success, error);
}

export function syncAmzSkuData(syncType: any, appContext: any, success: any, error: any) {
    return post(`/amazon/costing/sync?type=${syncType}`, null, appContext, success, error);
}

export function saveAdSpend(adSpendData: any, appContext: any, success: any, error: any) {
    return post(`/amazon/adspend/save`, adSpendData, appContext, success, error);
}

export function getAdSpendData(dates: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/adspend/get?page=${pageNumber}&size=${pageSize}`, dates, appContext, success, error);
}

export function getTotalAdCostTrend(product: any, period: any, count: any, appContext: any, success: any, error: any) {
    return get(`/amazon/adspend/trend?product=${product}&period=${period}&count=${count}`, appContext, success, error);
}

export function getHourlyAdCostTrend(startDate: any, endDate: any, appContext: any, success: any, error: any) {
    return get(`/amazon/adspend/trend/hourly?startDate=${startDate}&endDate=${endDate}`, appContext, success, error);
}

export function getAdSpendTrend(startDate: any, endDate: any, appContext: any, success: any, error: any) {
    return get(`/amazon/adspend/trend/order?startDate=${startDate}&endDate=${endDate}`, appContext, success, error);
}

export function getTransactionFee(pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/transaction/fee?page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getTransaction(data: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction?page=${pageNumber}&size=${pageSize}${data.sorting}`, data, appContext, success, error);
}

export function saveTransactionData(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/save`, data, appContext, success, error);
}

export function resolveDuplicate(rowId: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/duplicate/resolve?rowId=${rowId}`, null, appContext, success, error);
}

export function syncTransaction(rowId: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/sync?rowId=${rowId}`, null, appContext, success, error);
}

export function deleteTransaction(rowId: any, appContext: any, success: any, error: any) {
    return remove(`/amazon/transaction?rowId=${rowId}`, appContext, success, error);
}

export function getDuplicateCount(appContext: any, success: any, error: any) {
    return get(`/amazon/transaction/duplicate/count`, appContext, success, error);
}

export function getTransactionType(appContext: any, success: any, error: any) {
    return get(`/amazon/transaction/type`, appContext, success, error);
}

export function saveCashFlow(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/cashflow`, data, appContext, success, error);
}

export function syncData(attribute: any, appContext: any, success: any, error: any) {
    return post(`/amazon/sync?attribute=${attribute}`, null, appContext, success, error);
}

export function syncCancellationDate(orderDate: any, appContext: any, success: any, error: any) {
    return post(`/amazon/cancellation/sync?orderDate=${orderDate}`, null, appContext, success, error);
}

export function syncReportData(data: any, appContext: any, success: any, error: any) {
    return postfile(`/amazon/report/sync`, data, appContext, success, error);
}

export function syncOrder(date: any, appContext: any, success: any, error: any) {
    return post(`/amazon/order/sync?orderDate=${date}`, null, appContext, success, error);
}

export function syncAll(date: any, appContext: any, success: any, error: any) {
    return post(`/amazon/all/sync?orderDate=${date}`, null, appContext, success, error);
}

export function syncOrderId(orderId: any, appContext: any, success: any, error: any) {
    return post(`/amazon/order/sync/id?orderId=${orderId}`, null, appContext, success, error);
}

export function syncSale(date: any, appContext: any, success: any, error: any) {
    return post(`/amazon/sale/sync?orderDate=${date}`, null, appContext, success, error);
}

export function syncPerf(date: any, appContext: any, success: any, error: any) {
    return post(`/amazon/performance/sync?orderDate=${date}`, null, appContext, success, error);
}

export function syncPerfZeroValue(appContext: any, success: any, error: any) {
    return post(`/amazon/performance/sync/zerovalue`, null, appContext, success, error);
}

export function syncTransactionZeroValue(appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/sync/zerovalue`, null, appContext, success, error);
}

export function syncTransactionAPI(sDate: any, eDate: any, appContext: any, success: any, error: any) {
    return post(`/amazon/transaction/sync/api?sDate=${sDate}&eDate=${eDate}`, null, appContext, success, error);
}

export function syncOrderZeroValue(appContext: any, success: any, error: any) {
    return post(`/amazon/order/sync/zerovalue`, null, appContext, success, error);
}

export function syncTrnStatus(appContext: any, success: any, error: any) {
    return post(`/amazon/order/sync/trnstatus`, null, appContext, success, error);
}

export function syncFeeSku(data: any, appContext: any, success: any, error: any) {
    return post(`/amazon/fee/sync/sku`, data, appContext, success, error);
}

export function getSyncStatus(appContext: any, success: any, error: any) {
   return get(`/amazon/sync/status`, appContext, success, error);
}

export function getSyncHistory(attribute: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return get(`/amazon/sync/history?attribute=${attribute}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getParameter(appContext: any, success: any, error: any) {
   return get(`/amazon/parameter`, appContext, success, error);
}

export function saveParameter(parameter: any, appContext: any, success: any, error: any) {
   return post(`/amazon/parameter`, parameter, appContext, success, error);
}

export function deleteSyncStatus(rowId: any, appContext: any, success: any, error: any) {
   return remove(`/amazon/sync?rowId=${rowId}`, appContext, success, error);
}

export function getRankHistory(sku: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return get(`/amazon/rank/history?sku=${sku}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getProductRank(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return get(`/amazon/inventory/rank?page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getRankTrend(sku: any, appContext: any, success: any, error: any) {
   return get(`/amazon/rank/trend?sku=${sku}`, appContext, success, error);
}

export function getPriceHistory(sku: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return get(`/amazon/price/history?sku=${sku}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getFeeHistory(sku: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return get(`/amazon/fee/history?sku=${sku}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function saveAttribute(attribute: any, appContext: any, success: any, error: any) {
   return post(`/amazon/inventory/attribute`, attribute, appContext, success, error);
}

export function setInventoryStatus(rowData: any, appContext: any, success: any, error: any) {
   return post(`/amazon/inventory/status`, rowData, appContext, success, error);
}

export function savePerfData(perfData: any, appContext: any, success: any, error: any) {
   return post(`/amazon/performance/save`, perfData, appContext, success, error);
}

export function saveNonAmazonOrder(orderData: any, appContext: any, success: any, error: any) {
   return post(`/amazon/order/nonamazon`, orderData, appContext, success, error);
}

export function getSyncReport(appContext: any, success: any, error: any) {
   return get(`/amazon/sync/report`, appContext, success, error);
}

export function getLatestTime(appContext: any, success: any, error: any) {
   return get(`/amazon/latesttime`, appContext, success, error);
}

export function getSkuAdSpendData(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
   return post(`/amazon/adspend/sku?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function saveAdProduct(data: any, appContext: any, success: any, error: any) {
   return post(`/amazon/adspend/product`, data, appContext, success, error);
}

export function splitVirtualProduct(data: any, appContext: any, success: any, error: any) {
   return post(`/amazon/adspend/product/split`, data, appContext, success, error);
}

export function syncAdSkuAttribute(appContext: any, success: any, error: any) {
   return post(`/amazon/adspend/sku/attribute`, null, appContext, success, error);
}

export function getAllProducts(appContext: any, success: any, error: any) {
   return get(`/amazon/inventory/product`, appContext, success, error);
}

export function syncAdSpend(date: any, appContext: any, success: any, error: any) {
   return post(`/amazon/adspend/sync?date=${date}`, null, appContext, success, error);
}

export function syncUnitIP(rowId: any, appContext: any, success: any, error: any) {
   return post(`/amazon/order/sync/ip?rowId=${rowId}`, null, appContext, success, error);
}
